<div class="me-4 pe-2">
  @if (withdrawAllowed()) {
    <button type="button" (click)="applyAction(requestStatusActionsEnum.Withdrawn)" class="btn btn-sm btn-outline-danger w-auto ms-2" type="button" translate="Request.Status.RequestOptions.Withdraw" [attr.data-testid]="'withdrawActionButton'"></button>
  }
  @if (restoreAllowed()) {
    <button type="button" (click)="applyAction(requestStatusActionsEnum.Restore)" class="btn btn-sm btn-success w-auto ms-2" type="button" translate="Request.Status.RequestOptions.Restore" [attr.data-testid]="'restoreActionButton'"></button>
  }
  @if (purgeAllowed()) {
    <button (click)="applyAction(requestStatusActionsEnum.Purge)" class="btn btn-sm btn-outline-secondary w-auto ms-2" type="button" translate="Request.Status.RequestOptions.Purge" [attr.data-testid]="'purgeActionButton'"></button>
  }
  @if (goToRequestAllowed()) {
    <button type="button" (click)="applyAction(requestStatusActionsEnum.GoToRequest)"class="btn btn-sm btn-success w-auto ms-2" type="button" translate="Request.Status.RequestOptions.GoToRequest" [attr.data-testid]="'goToRequestActionButton'"></button>
  }
  @if (downloadAllowed()) {
    <button type="button" (click)="applyAction(requestStatusActionsEnum.Download)" class="btn btn-sm btn-success w-auto ms-2" type="button" translate="Request.Status.RequestOptions.Download" [attr.data-testid]="'downloadActionButton'"></button>
  }
  @if (allowedToDoAction()) {
    <button type="button" (click)="$event.stopPropagation();" class="btn statusheader action-button border-0 p-0 ms-2" data-bs-toggle="dropdown" aria-expanded="false">
      <i class="bi bi-three-dots bi-large"></i>
    </button>
  }
  <div class="dropdown float-end">
    <ul class="dropdown-menu w-auto">
      <!-- <li *ngIf="withdrawAllowed()" (click)="applyAction(requestStatusActionsEnum.Withdrawn)" class="dropdown-item" translate="Request.Status.RequestOptions.WithdrawRequest"></li> -->
      @if (editReqeustAllowed()) {
        <li>
          <a class="dropdown-item" (click)="applyAction(requestStatusActionsEnum.EditRequest)" translate="Request.Status.RequestOptions.EditRequestDetails"></a>
        </li>
      }
      @if (exportAllowed() && showMSplugins) {
        <li>
          <a class="dropdown-item" (click)="applyAction(requestStatusActionsEnum.Export)" translate="Request.Status.RequestOptions.ExportRequest"></a>
        </li>
      }
      <!-- <li *ngIf="purgeAllowed()" (click)="applyAction(requestStatusActionsEnum.Purge)" class="dropdown-item" translate="Request.Status.RequestOptions.PurgeRequest"></li> -->
      <!-- <li *ngIf="restoreAllowed()" (click)="applyAction(requestStatusActionsEnum.Restore)" class="dropdown-item" translate="Request.Status.RequestOptions.RestoreRequest"></li> -->
      @if (deleteAllowed()) {
        <li>
          <a class="dropdown-item" (click)="applyAction(requestStatusActionsEnum.Delete)" translate="Request.Status.RequestOptions.DeleteRequest"></a>
        </li>
      }
      @if (becomeOwnerAllowed()) {
        <li>
          <a class="dropdown-item" (click)="applyAction(requestStatusActionsEnum.BecomeOwner)" translate="Request.Status.RequestOptions.BecomeOwner"></a>
        </li>
      }
    </ul>
  </div>
</div>